import { AfterContentInit, Directive, EventEmitter, Output } from "@angular/core";

@Directive({
  selector: "[onFocusEditable]",
  standalone: false,
})
export class BfxFocusEditableDirective implements AfterContentInit {
  @Output("onFocusEditable")
  public editableEvent: EventEmitter<BfxFocusEditableDirective> = new EventEmitter();

  public ngAfterContentInit(): void {
    setTimeout(() => {
      this.editableEvent.next(this);
    }, 4);
  }
}
